import * as yup from 'yup';

export const formSchema = yup.object({
  productName: yup.string().nullable(),
  variantName: yup.string().nullable(),
  depoName: yup.string().nullable(),
  priceBeforeDiscount: yup.number().nullable(),
  priceAfterDiscount: yup.number().nullable(),
  costCentre: yup.number().nullable(),
  discountType: yup.string().nullable(),
  discountValue: yup
    .number()
    .required('Discount Value is required'),
  startDateAndTime: yup
    .date()
    .required('Start Date and Time is required')
    .min(
      new Date(),
      'Start Date and Time should not be in past'
    ),
  endDateAndTime: yup
    .date()
    .required('End Date and Time is required')
    .min(
      new Date(),
      'End Date and Time should not be in past'
    ),
});

export type TFormData = yup.InferType<typeof formSchema>;
